import { render, staticRenderFns } from "./ManagersSelector.vue?vue&type=template&id=cc5370e6&"
import script from "./ManagersSelector.vue?vue&type=script&lang=js&"
export * from "./ManagersSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports